<template>
    <div class="content">
        <van-search v-model="value" placeholder="输入IMEI编码" />
        <div style="padding:10px 11px;background-color: #ffffff;" class="list-style" v-for="(item, index) in list"
            :key="index" @click="toDetail(item.imei)">
            <div class="content-avatar"><img style="width: 50px; height: 50px;" src="../assets/images/avatar.png" alt="" /></div>
            <div style="color:#333333;font-size:18px;font-weight: 700;line-height: 36px; margin-left: 20%;">IMEI</div>
            <div
                style="color:#333333;font-size:16px;font-weight: 700;line-height: 28px;margin-top: 0px;position: relative;margin-left: 20%;">
                <!-- {{item.truck_no}} -->{{ item.imei }}
                <span style="position:absolute;right: 80px;bottom: 0px;font-size: 12px;color: #57C2F5;"
                    @click.stop="toDetail(item.imei)">查看详情</span>
                <span style="position:absolute;right: 10px;bottom: 0px;font-size: 12px;color: red;"
                    @click.stop="unbind(item)">解除绑定</span>
            </div>
        </div>
        <div class="addBtn" @click="toBangding()">
            新增绑定
        </div>
    </div>
</template>

<script>
import preventBack from 'vue-prevent-browser-back';
export default {
    mixins: [preventBack],//阻止返回上一页
    name: 'binding',
    data() {
        return {
            //搜索框
            value: "",

            filter: {
                code: "",
            },
            list: [],
            loading: null,
            // url: "http://192.168.88.80:8011/",
            url:"http://www.bd-gps.com/bdgps/",
            // url:"http://chaxun.kcbdgps.com/bdgps/",
            // url: "http://192.168.88.211:8875/",
            BtnX: 0,
            BtnY: 0,
        }
    },
    methods: {
        getBindingList() {
            var _this = this
            this.loading = this.$toast.loading('请稍等', {
                coverColor: "rgba(0,0,0,0.5)",
            });
            this.$axios.get(this.url + "api/BindImei/binding_grid", {
                params: {
                    code: this.filter.code
                }
            })
                .then(res => {
                    this.loading.hide();
                    if (res.data.result == "success") {
                        this.list = res.data.Data
                        if (this.list.length == 0) {
                            this.$dialog({
                                id: 'my-dialog',
                                title: "提示！",
                                content: "当前用户未绑定IMEI设备！",
                                noOkBtn: true,
                            });
                        }
                    } else {
                        this.$dialog({
                            id: 'my-dialog',
                            title: "提示！",
                            content: res.data.Message,
                            noOkBtn: true,
                        });
                    }
                })
                .catch((error) => {
                    this.loading.hide();
                    console.log(error)
                })
        },
        unbind(item) {
            var _this = this
            this.loading = this.$toast.loading('请稍等', {
                coverColor: "rgba(0,0,0,0.5)",
            });
            this.$axios.get(this.url + "api/BindImei/unbind", {
                params: {
                    imei: item.imei
                }
            })
                .then(res => {
                    this.loading.hide();
                    if (res.data.result == "success") {
                        window.location = this.url + "index.html?type=Search"
                    } else {
                        this.$dialog({
                            id: 'my-dialog',
                            title: "提示！",
                            content: res.data.Message,
                            noOkBtn: true,
                        });
                    }
                })
                .catch((error) => {
                    this.loading.hide();
                    console.log(error)
                })
        },
        toBangding() {
            window.location = this.url + "index.html?type=binding"
        },
        toDetail(imei) {
            this.$router.push({
                name: 'imeiDetail',
                params: { detail: "", code: "", imei: imei }
            })
        },
        GetRequest() {
            var url = window.location.search
            //获取url中"?"符后的字串  
            var theRequest = new Object();
            if (url.indexOf("?") != -1) {
                let str = url.substr(1);
                let strs = str.split("&");
                for (var i = 0; i < strs.length; i++) {
                    theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
                }
            }
            return theRequest;
        }
    },
    watch: {
        "filter": {
            handler(val) {
                if (val.imei != '') {
                    this.focus1 = true
                }
            }, deep: true
        },
    },
    created() {
        let dizhi = this.GetRequest()
        if (dizhi.code) {
            this.filter.code = dizhi.code
        }
        this.getBindingList()
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
    width: 100%;
    height: 100%;
    overflow-y: scroll;
}

.list-style {
    position: relative;
    /* display: flex; */
}

.list-style .content-avatar {
    overflow: hidden;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    position: absolute;
    margin-top: 2%;
}

.list-style::after {
    position: absolute;
    height: 1px;
    content: "";
    background-color: #c8c7cc;
    bottom: 0px;
    left: 11px;
    right: 11px;
}

.addBtn {
    position: fixed;
    width: 111px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    border-radius: 8%;
    background-color: #00AE71;
    color: #ffffff;
    bottom: 80px;
    right: 30px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, .12), 0 0 8px rgba(0, 0, 0, .04);
    z-index: 999;
}
</style>

<style>.van-icon-search:before {
    color: #00AE71;
}</style>



// WEBPACK FOOTER //
// src/pages/binding_list.vue